import React from "react";
import {SubmitHandler, useForm} from "react-hook-form";
import ErrorMsg from "../err-message/ErrorMsg";

interface IFormInput {
    password: string;
    confirmPassword:string;
}


const NewPassword = () => {
  const {
        register,
        handleSubmit,
        formState: {errors},
    } = useForm<IFormInput>();
    const onSubmit: SubmitHandler<IFormInput> = (data) => {
        if (data) {
          console.log('data ', data)

        }
    };
  return (
    <main>
      <div className="container">
        <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6 col-md-6 d-flex flex-column align-items-center justify-content-center">
                <div className="card mb-3">
                  <div className="card-body">
                    <div className="pt-4 pb-2">
                      <h5 className="card-title text-center pb-0 fs-4">
                        Create New Password
                      </h5>
                    </div>
                    <form className="row g-3 needs-validation" onSubmit={handleSubmit(onSubmit)}>
                      <div className="col-12 col-md-12">
                        <label htmlFor="yourUsername" className="form-label">
                          New Password
                        </label>
                        <div className="input-group has-validation">
                          <input
                              {...register("password", {required: `Password is required!`})}
                              name="password"
                              id="password"
                              type="password"
                              placeholder="Please Enter new Password"
                              className="form-control p-2"
                          />
                        </div>
                        <ErrorMsg msg={errors.password?.message as string}/>
                      </div>
                      <div className="col-12 col-md-12">
                        <label htmlFor="yourUsername" className="form-label">
                          Confirm Password
                        </label>
                        <div className="input-group has-validation">
                          <input
                              {...register("confirmPassword", {required: `Confirm Password is required!`})}
                              name="password"
                              id="confirmPassword"
                              type="confirmPassword"
                              placeholder="Please Enter Confirm Password"
                              className="form-control p-2"
                          />
                        </div>
                        <ErrorMsg msg={errors.confirmPassword?.message as string}/>
                      </div>
                      <div className="col-12">
                        <button className="btn btn-primary w-100" type="submit">
                          Sent Email
                        </button>
                      </div>
                      <div className="col-12">
                        <p className="small mb-0"></p>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};
export default NewPassword;
